import Search from "../Search/Search";
import { initials } from "../../qa";
import styles from "./Topbar.module.css";

export default function Topbar({
  reviewer,
  online,
  showKeys,
  onPick,
  onFilter,
  onSets,
  onExport,
  onToggleKeys,
  onSwitch,
}) {
  return (
    <header className={styles.topbar}>
      <div className={styles.title}>
        <h2 className={styles.heading}>Question Bank</h2>
        <p className={styles.tag}>NSSC Treasure Hunt / Verification Mode</p>
      </div>
      <Search onPick={onPick} />
      <div className={styles.controls}>
        <button type="button" className={styles.control} onClick={onFilter}>Filter</button>
        <button type="button" className={styles.control} onClick={onSets}>Sets</button>
        <button type="button" className={styles.control} onClick={onExport}>Export</button>
        <button
          type="button"
          className={`${styles.control} ${showKeys ? styles.on : ""}`}
          aria-pressed={showKeys}
          onClick={onToggleKeys}
        >
          Keys
        </button>
        <span className={`${styles.sync} ${online ? "" : styles.offline}`} role="status">
          {online ? "● Live" : "○ Offline"}
        </span>
        <button
          type="button"
          className={styles.avatar}
          onClick={onSwitch}
          aria-label={`Reviewer ${reviewer}. Tap to switch reviewer`}
          title={reviewer}
        >
          {initials(reviewer)}
        </button>
      </div>
    </header>
  );
}
